module.exports = __webpack_public_path__ + "img/help3.034764b2.jpg";